import { EyeIcon, EyeOffIcon } from "lucide-react";
import React from "react";
import { Group, type InputProps } from "react-aria-components";

import { ToggleButton } from "@/components/ui/button";
import { Input } from "@/components/ui/field";
import { composeTailwindRenderProps } from "@/components/ui/utils";

export function PasswordInput({ className, ...props }: InputProps) {
  const [isPasswordVisible, setIsPasswordVisible] = React.useState(false);

  return (
    <Group
      data-ui="control"
      className={[
        "grid",
        "grid-cols-[1fr_calc(theme(size.5)+20px)]",
        "sm:grid-cols-[1fr_calc(theme(size.4)+20px)]",
      ].join(" ")}
    >
      <Input
        {...props}
        className={composeTailwindRenderProps(className, [
          "peer",
          "col-span-full",
          "row-start-1",
          "pe-10 sm:pe-9",
        ])}
        type={isPasswordVisible ? "text" : "password"}
      />
      <ToggleButton
        size="icon-sm"
        variant="ghost"
        aria-label="Show password"
        isSelected={isPasswordVisible}
        onChange={setIsPasswordVisible}
        excludeFromTabOrder
        className={[
          "group",
          "focus-visible:-outline-offset-1",
          "row-start-1",
          "-col-end-1",
          "place-self-center",
        ].join(" ")}
      >
        {isPasswordVisible ? (
          <EyeOffIcon className="text-muted/75 group-hover:text-foreground" />
        ) : (
          <EyeIcon className="text-muted/75 group-hover:text-foreground" />
        )}
      </ToggleButton>
    </Group>
  );
}
